import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Leaf, Mail, ArrowLeft } from 'lucide-react'
import toast from 'react-hot-toast'
import api from '../../services/api'

export default function ForgotPasswordPage() {
    const[email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const[success, setSuccess] = useState(false)

    const onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            await api.post('/api/auth/forgot-password', { email })
            setSuccess(true)
        } catch (error) {
            toast.error("Erreur de connexion au serveur.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-sage-50">
            <div className="card max-w-md w-full relative z-10 shadow-xl bg-white p-8">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Leaf className="w-8 h-8 text-sage-600" />
                    </div>
                    <h1 className="text-2xl font-serif text-sage-800">Mot de passe oublié</h1>
                </div>

                {success ? (
                    <div className="text-center animate-in zoom-in-95">
                        <div className="bg-green-50 text-green-700 p-4 rounded-xl border border-green-200 mb-6 text-sm">
                            Si cette adresse est liée à un compte, un email contenant un lien de réinitialisation vient de vous être envoyé.
                        </div>
                        <Link to="/admin/login" className="btn bg-gray-100 text-gray-700 w-full flex items-center justify-center">
                            Retour à la connexion
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-4">
                        <p className="text-sm text-gray-500 mb-4 text-center">Entrez l'adresse email associée à votre cabinet pour recevoir un lien de réinitialisation.</p>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Email de connexion</label>
                            <div className="relative">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                <input 
                                    type="email" required autoFocus
                                    value={email} onChange={e => setEmail(e.target.value)} 
                                    className="w-full pl-10 py-3 bg-gray-50 focus:bg-white" 
                                    placeholder="contact@cabinet.fr"
                                />
                            </div>
                        </div>

                        <button type="submit" disabled={loading || !email} className="w-full btn btn-primary py-3 flex items-center justify-center">
                            {loading ? <div className="spinner w-5 h-5 border-white"/> : "Envoyer le lien"}
                        </button>

                        <div className="text-center mt-6">
                            <Link to="/admin/login" className="text-sm text-sage-600 hover:underline flex items-center justify-center gap-1">
                                <ArrowLeft className="w-4 h-4"/> Annuler et revenir
                            </Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    )
}